namespace GeniuzPOS.Purchase {
    export interface PoApprovalForm {
        DocType: Serenity.LookupEditor;
        Level: Serenity.EnumEditor;
        Mininum: Serenity.DecimalEditor;
        ApprGroupCode: Serenity.LookupEditor;
    }

    export class PoApprovalForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoApproval';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoApprovalForm.init)  {
                PoApprovalForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.EnumEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PoApprovalForm, [
                    'DocType', w0,
                    'Level', w1,
                    'Mininum', w2,
                    'ApprGroupCode', w0
                ]);
            }
        }
    }
}
